import { UserProfile } from './type';

export const isUserBuyer = (userRole: string | null | undefined) => 
  userRole?.toLowerCase() === 'buyer' || userRole?.toLowerCase() === 'general user';
export const isUserRealtor = (userRole: string | null | undefined) => userRole?.toLowerCase() === 'realtor';
export const isUserAdmin = (userRole: string | null | undefined) => userRole?.toLowerCase() === 'admin';
export const isUserGeneral = (userRole: string | null | undefined) => userRole?.toLowerCase() === 'general user';
export const isUserBlogWriter = (userProfile: UserProfile | null | undefined) => userProfile?.isBlogWriter === true;
export const isUserSuperAdmin = (userProfile: UserProfile | null | undefined) => userProfile?.isSuperAdmin === true;